// extracted by mini-css-extract-plugin
export var content = "_pq-1";
export var fullScreen = "_pq-0";